"use client";

import * as React from "react";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";
import { cva } from "class-variance-authority";

const inputVariants = cva(
  "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "border-input bg-transparent",
        theme: "border-theme bg-theme-0 text-theme-0 font-theme",
        search: "border-theme bg-theme-0 text-theme-0 font-theme pl-9",
      },
    },
    defaultVariants: {
      variant: "theme",
    },
  }
);

interface InputProps extends React.ComponentProps<"input"> {
  variant?: "default" | "theme" | "search";
}

function Input({ className, type, variant = "theme", ...props }: InputProps) {
  return (
    <div className="relative">
      {variant === "search" && (
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-theme-2" />
      )}

      <input
        type={type}
        data-slot="input"
        className={cn(inputVariants({ variant }), className)}
        {...props}
      />
    </div>
  );
}

export { Input };
